import { AudioComponent } from "@educaplay/core";
import styles from "./bankAudio.module.scss";
import clsx from "clsx";
import BankText from "../BankText";
import PropTypes from "prop-types";

const BankAudio = ({ text, source, hideText, dashed }) => {
  const shouldShowText = text && !hideText;

  return (
    <div className={clsx(styles.audioContainer, dashed && styles.dashed)}>
      <div className={styles.audioPlayer}>
        <AudioComponent
          source={source}
          className={styles.audioComponent}
          big={true}
          autoplay={false}
        />
      </div>

      {shouldShowText && (
        <div className={styles.textArea}>
          <BankText text={text} dashed={dashed} />
        </div>
      )}
    </div>
  );
};

BankAudio.propTypes = {
  text: PropTypes.string,
  source: PropTypes.string.isRequired,
  hideText: PropTypes.bool,
  dashed: PropTypes.bool,
};

BankAudio.defaultProps = {
  text: "",
  hideText: false,
  dashed: false,
};

export default BankAudio;
